<template>
  <div>
    <StoreBanner :imageList="this.config.banner_top.imageList"></StoreBanner>
    <StoreTitle></StoreTitle>
    <StoreList></StoreList>
    <StoreBanner3></StoreBanner3>
  </div>
</template>

<script>
import StoreBanner from "@/yintai/view/content/store/StoreBanner.vue";
import StoreTitle from "@/yintai/view/content/store/StoreTitle.vue";
import StoreList from "@/yintai/view/content/store/StoreList.vue";

import StoreBanner3 from "@/yintai/view/content/store/StoreBanner3.vue";
import { fetchConfig } from "@/yintai/api/config";

export default {
  name: "store",
  components: {
    StoreBanner,
    StoreTitle,
    StoreList,
    StoreBanner3,
  },
  data() {
    return {
      config: {
        banner_top: {
          imageList: [],
        },
      },
    };
  },
  async mounted() {
    const response = await fetchConfig({ id: 3 });
    this.config = response.data.data.item.config;
  },
  methods: {},
};
</script>
